import UserModel from './UserModel.js';
import VerifiedTaskTemplateModel from './VerifiedTaskTemplateModel';
import { taskWorkTypeOptions } from '../constants/options.js';
import AbstractTaskTemplateModel from './AbstractTaskTemplateModel';
import { TemplateType } from '../mixins/TemplateLibraryMixin.js';
import { titleCase } from '../util';

export default class TaskTemplateModel extends AbstractTaskTemplateModel {
  constructor(data, args) {
    super();

    this.init(data || {});
    this.categoryRequired = args?.categoryRequired || false;
  }

  init(data) {
    super.init(data);
    this.work_type = data.work_type ? taskWorkTypeOptions.find(option => option.id === data.work_type) : null;
    this.active_task_count = data.active_task_count || 0;
    this.active_pm_schedule_count = data.active_pm_schedule_count || 0;
    this.verified_task_template = data.verified_task_template ? new VerifiedTaskTemplateModel(data.verified_task_template) : null;
    this.modified_from_verified_template = 'modified_from_verified_template' in data ? data.modified_from_verified_template : false;
    this.added = data.added ? new Date(data.added) : null;
    this.added_by = data.added_by ? new UserModel(data.added_by) : null;
    this.updated_by = data.updated_by ? new UserModel(data.updated_by) : null;
  }

  get tableCheckboxDisabled() {
    return this.categoryRequired && !this.category;
  }

  get workTypeName() {
    return this.work_type?.display_label || '';
  }

  get scheduleDisplay() {
    return this.verified_task_template
      ? titleCase(this.verified_task_template?.schedule)
      : null;
  }

  get isVerifiedOrUnmodifiedVerified() {
    return (this.verified_task_template && !this.modified_from_verified_template);
  }

  get fromVerified() {
    return !!(this.verified_task_template && this.modified_from_verified_template);
  }

  get createdDisplayDate() {
    return (this.verified_task_template && this.added && !this.modified_from_verified_template)
      ? this.verified_task_template.createdDisplayDate
      : this.created;
  }

  get creatorName() {
    if (this.isVerifiedOrUnmodifiedVerified) {
      return this.verified_task_template.creatorName;
    }
    return this.user ? this.user.fullName : '';
  }

  get updatedDisplayDate() {
    return (this.isVerifiedOrUnmodifiedVerified && this.added)
      ? this.verified_task_template.updatedDisplayDate
      : this.updated;
  }

  get updaterName() {
    let name = this.updated_by ? this.updated_by.fullName : this.company?.name;

    if (this.isVerifiedOrUnmodifiedVerified) {
      name = this.verified_task_template.updaterName;
    }

    return name;
  }

  get adderName() {
    return (this.added_by) ? this.added_by.fullName : null;
  }

  get companyImageUrl() {
    if (this.modified_from_verified_template) return null;
    return this.verified_task_template?.company?.thumbnail_url;
  }

  get companyName() {
    if (!this.isVerifiedOrUnmodifiedVerified) return this.company?.name;
    return this.verified_task_template?.company?.name;
  }

  get locked() {
    return this.verified_task_template?.locked || false;
  }

  get templateType() {
    return TemplateType.LIBRARY;
  }
}
